/* global __CLIENT__*/
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';

import EntityNotFound from '../../../components/EntityNotFound';
import ElementType from './ElementType';

import { ElementTypeActions } from '../../../actions/elementType';
import { notFoundSelector, isNotFound } from '../../../reducers/notFound';
import {
  currentElementTypeSelector,
  currentElementTypeIdSelector,
} from '../../../reducers/elementTypes';
import {
  iconsSelector,
  getIcon,
} from '../../../reducers/icons';
import '../../../styles/ElementType.css';

const ElementTypeContainerSelector = immutableCreatorSelector(
  [notFoundSelector, currentElementTypeSelector, currentElementTypeIdSelector, iconsSelector],
  (notFound, elementType, currentElementTypeId, icons) => {
    return {
      notFound: isNotFound(notFound, 'elementTypes', currentElementTypeId),
      icon: getIcon(Map(), elementType, icons),
      elementType,
      currentElementTypeId,
    };
  }
);

@connect(ElementTypeContainerSelector)
export default class ElementTypeContainer extends Component {
  static propTypes = {
    elementType: PropTypes.instanceOf(Map).isRequired,
    currentElementTypeId: PropTypes.string,
    notFound: PropTypes.bool,
    dispatch: PropTypes.func,
  };

  componentDidMount() {
    const { elementType, currentElementTypeId, dispatch } = this.props;

    if (!elementType) {
      dispatch(ElementTypeActions.getElementType(currentElementTypeId, []));
    }
  }

  render() {
    const { notFound, currentElementTypeId, elementType } = this.props;

    if (notFound) {
      return <EntityNotFound type="Element Type" id={currentElementTypeId} />;
    }

    return <ElementType elementType={elementType} {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/ElementType/ElementTypeContainer.js